// @ts-nocheck
import React, { Component } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { withRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

const localStorageDefined = () => typeof localStorage !== 'undefined';

class BaseSelectProject extends Component {
  static defaultProps = {
    placeholder: 'Select a project',
    showProjectId: true,
    customer: null,
    taskType: null,
    disallowedTaskTypes: null,
    includeTestProjects: true,
    exclusivelySyntheticProjects: false,
    width: '500px',
    remoAdminPersonaId: undefined,
    remoAdminCtx: null,
  };

  constructor(props) {
    super(props);
    if (props.remoAdminCtx && props.value?.value) {
      props.remoAdminCtx.setSelectedProject(props.value.value);
    }
    this.state = {
      recentProjects: this.getRecentProjects(),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.storeRecentProject(this.props.value);
    }
  }

  getRecentProjects() {
    if (!localStorageDefined()) return [];
    return JSON.parse(localStorage.getItem('recentProjects')) || [];
  }

  storeRecentProject(selectedProject) {
    if (!localStorageDefined() || !selectedProject || !selectedProject.value) return;

    let recentProjects = this.getRecentProjects();
    recentProjects = recentProjects.filter(p => p.value !== selectedProject.value);
    recentProjects.unshift(selectedProject);

    if (recentProjects.length > 8) {
      recentProjects.pop();
    }

    localStorage.setItem('recentProjects', JSON.stringify(recentProjects));
    this.setState({ recentProjects });
  }

  async getProjectResults(search) {
    const {
      customer,
      taskType,
      disallowedTaskTypes,
      includeTestProjects,
      exclusivelySyntheticProjects,
      remoAdminPersonaId,
      remoAdminCtx,
    } = this.props;

    const personaId = remoAdminPersonaId || remoAdminCtx?.currentPersona?._id;

    if (personaId) {
      const query = { personaId, search };
      return await apiFetch(null, 'internal/remo-admin/projects', { query });
    }

    const query = Object.assign(
      {
        includeTestProjects,
        exclusivelySyntheticProjects,
        customer,
        search,
      },
      taskType ? { taskType } : { disallowedTaskTypes },
    );
    const result = await apiFetch(null, 'corp-api/find/projects', { query });
    return result.projects;
  }

  async fetchProjects(search) {
    const { customer, taskType, showAllByDefault } = this.props;

    if (!showAllByDefault && !search && (!customer || !taskType)) {
      const recentProjects = this.state.recentProjects;
      return { options: recentProjects };
    }

    try {
      const results = await this.getProjectResults(search);
      const options =
        results.map(project => {
          const value = project.id ?? project._id;
          const label = this.props.showProjectId ? `${project.name} (${value})` : project.name;
          return { label, value };
        }) ?? [];

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    const { width } = this.props;

    const { recentProjects } = this.state;

    const setProjectListenerProps = {
      ...this.props,
      onChange: e => {
        if (!this.props.noRemoAdminCtxUpdate) {
          this.props.remoAdminCtx?.setSelectedProject(e?.value ?? '');
          this.props.remoAdminCtx?.setSelectedProjectName(e?.label ?? '');
        }
        this.props.onChange?.(e);
      },
    };

    return (
      <div style={{ width }}>
        <Select
          {...setProjectListenerProps}
          loadOptions={this.fetchProjects.bind(this)}
          ignoreCase={true}
          defaultOptions={recentProjects}
          key={recentProjects.length > 0 ? recentProjects[0].value : 'recentProjects'}
        />
      </div>
    );
  }
}

export default withRemoAdminCtx(BaseSelectProject);
